import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { usePageMeta, useSite } from "@/lib/store";
import { WRAP } from "@/components/store/Chrome";
import { renderBody } from "@/components/store/Icon";

export const SHIPPING_ANCHOR = "shipping-return-and-refund-policy";
export const RETURNS_ANCHOR = "eligibility-for-a-return-replacement-or-refund";

function PolicyPage({ title, body, testid }) {
  const { hash } = useLocation();
  usePageMeta(title && `${title} | Vinyl Record Vault`);
  useEffect(() => {
    if (!body) return;
    const el = hash && document.getElementById(hash.slice(1));
    if (el) setTimeout(() => el.scrollIntoView({ behavior: "smooth", block: "start" }), 50);
    else window.scrollTo(0, 0);
  }, [hash, body]);
  return (
    <div className={`${WRAP} pt-12`}>
      <p className="label-caps text-[11px] text-red mb-1.5">Vinyl Record Vault</p>
      <h1 className="font-head font-extrabold text-4xl sm:text-5xl tracking-tight border-b-2 border-black pb-4" data-testid={`${testid}-title`}>{title}</h1>
      <div className="prose-vrv policy-body mt-10 max-w-3xl text-[#222]" data-testid={`${testid}-body`}>{renderBody(body || "")}</div>
    </div>
  );
}

export function ContactPage() {
  const { site } = useSite();
  const p = site?.policies;
  return <PolicyPage title={p?.contact_title} body={p?.contact_body} testid="contact-page" />;
}

export function TermsPage() {
  const { site } = useSite();
  const p = site?.policies;
  return <PolicyPage title={p?.terms_title} body={p?.terms_body} testid="terms-page" />;
}
